var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"file-label uploader",attrs:{"for":_vm.fileId}},[_vm._t("default"),_vm._v(" "),_c('input',{ref:"files",attrs:{"type":"file","accept":"image/*","id":_vm.fileId},on:{"change":_vm.uploadImage}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }